import React from 'react';
import AuthService from './authService.js';
import TpJobItem from '../Domain/ThirdParty/TpJob/TpJobItem';
import serviceHelper from '../Helpers/serviceHelper.js';
import SearchParams from '../Elements/SearchParams';
import TpJobSearchParams from '../Contents/Operations/TpJob/TpJobSearchParams';

export default class TpJobService extends React.Component {
  static GetAllItemsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpJobSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/TpJob/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static GetById(id, clearCache = false) {
    const url = `/api/TpJob/GetById/${id}?clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetThirdPartyJobStatusList() {
    const url = '/api/TpJob/GetThirdPartyJobStatusList';
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetTpJobStatusList() {
    const url = '/api/TpJob/GetTpJobStatusList';
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static EditMultiple(item, itemList, allItemsInTheSearchAreSelected, searchParameters) {
    const url = '/api/TpJob/EditMultiple';
    item.AllItemsInTheSearchAreSelected = allItemsInTheSearchAreSelected;
    item = serviceHelper.ConvertAllPropertyToString(item);
    item.Ids = itemList.map((s) => s.TpJobId);
    item.SearchParameters = { ...searchParameters };

    return AuthService.getInstance().CallBackendFunctionPut(url, item);
  }

  static async ExportThirdPartyOrphanedJobsToExcel() {
    const url = '/api/TpJob/ExportThirdPartyOrphanedJobsToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url);
  }

  static ExportAdminExcelAsync(searchItem) {
    const url = `/api/TpJob/ExportAdminExcelAsync?searchItem=${JSON.stringify(searchItem)}`;
    return AuthService.getInstance().CallBackendFunctionPost(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpJobItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static GetClientUnitClientNameById(id) {
    let authService = AuthService.getInstance();
    let url = '/api/ClientUnit/GetClientUnitClientNameById/' + id + '?clearCache=false';
    return authService.CallBackendFunction(url);
  }

  static GenerateAssignmentPayment(item, searchItem, allItemsInTheSearchAreSelected) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/TpClientInvoice/GenerateAssignmentPayment?searchParams=' +
        JSON.stringify(searchItem) +
        '&allItemsInTheSearchAreSelected=' +
        JSON.stringify(allItemsInTheSearchAreSelected),
      JSON.stringify(item)
    );
  }
}
